module.exports = flarum.core.compat['forum/utils/KeyboardNavigatable'];